import React, { useState, useMemo, Suspense } from 'react'

import { ListSkeleton } from '@/components/ListSkeleton'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import ErrorPage from '@/pages/Error'
import { Divider, Skeleton, Stack, Typography } from '@mui/material'
import { WalletTabHeader } from './parts/WalletTabHeader'
import { PaymentList } from './parts/PaymentList'
import { FilterBar } from '../../components/FilterBar'
import { PaymentFilterBottomSheet } from './parts/PaymentFilterBottomSheet'
import { useDisclosure } from '@/hooks/useDisclosure'
import { PaymentHistoryFilters } from '@/api/payment/types'

const WalletTab: React.FC = () => {
  const [filters, setFilters] = useState<PaymentHistoryFilters>({})
  const { isOpen: showFilters, open: openFilters, close: closeFilters } = useDisclosure()

  const activeFilterKeys = useMemo(
    () =>
      Object.entries(filters)
        .filter(([, v]) => v !== null && v !== undefined && v !== '')
        .map(([k]) => k)
        .filter((k) => {
          if (k === 'activePeriod') return false // não conta o select de período como filtro ativo
          return true
        }),
    [filters]
  )

  const handleApplyFilters = (appliedFilters: Record<string, unknown>) => {
    setFilters(appliedFilters as PaymentHistoryFilters)
  }

  const handleClearFilters = () => {
    setFilters({})
  }

  return (
    <ErrorBoundary fallback={<ErrorPage />}>
      <Suspense
        fallback={
          <Stack direction="column" width="100%" spacing={2}>
            <Skeleton variant="rounded" width="100%" height={68} sx={{ borderRadius: 3 }} />
            <Skeleton variant="rounded" width="100%" height={76} sx={{ borderRadius: 2 }} />
            <Divider sx={{ my: 1 }} />
            <Skeleton variant="rounded" width="50%" height={24} sx={{ borderRadius: 2 }} />
            <ListSkeleton.Wrapper count={3}>
              <ListSkeleton.PaymentItem />
            </ListSkeleton.Wrapper>
          </Stack>
        }
      >
        <Stack direction="column" width="100%" spacing={2}>
          <WalletTabHeader />
          <Divider sx={{ my: 1 }} />
          <Typography variant="subtitle1" fontWeight="bold">
            Histórico de transações
          </Typography>
          <FilterBar
            activeFilterKeys={activeFilterKeys}
            onOpenFilters={openFilters}
            onClearFilters={handleClearFilters}
          />
          <PaymentList filters={filters} />
            <PaymentFilterBottomSheet
              filters={filters}
              onApply={handleApplyFilters}
              onClear={handleClearFilters}
              isOpen={showFilters}
              onClose={closeFilters}
            />
        </Stack>
      </Suspense>
    </ErrorBoundary>
  )
}

export default WalletTab
